// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import routes from './router/index'
// import store from './store/store.js'
import VueRouter from 'vue-router'
//可选是否选择注入Store管理
// import store from './store/'
import {
	routerMode,
	baseUrl,
	routerbase
} from "./config/env"
// import FastClick from 'fastclick'

import "./utils/Array";
//Fly npm引入方式
const Fly = require("flyio/dist/npm/fly");
import {
	getSession,
	setSession
} from './utils/index.js';
import {
	jsToken
} from './service/interface';

import mask from 'vanilla-masker';
Vue.prototype.mask = mask;

import { Checkbox, CheckboxGroup, Button, Dialog, Radio, RadioGroup } from 'vant';

Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Radio);
Vue.use(RadioGroup);

require('es6-promise').polyfill();

//创建fly实例
const fly = new Fly();
fly.interceptors.request.use((config, promise) => {
	config.headers["Content-Type"] = "application/json";
	//设置超时时间
	config.timeout = config.timeout || 60000; //30秒超时
	console.log(config.body);
	return config;
})


//配置请求基地址
fly.config.baseURL = baseUrl;
//挂载在vue的实例上
Vue.prototype.$http = (service, success, error) => {
	let _jsToken = getSession('_tmp_jsToken');
	if (_jsToken) {
		_sendFun(service, _jsToken, success, (data) => {
			if (data.status === 401) {
				setTimeout(() => {
					_getJsToken((result) => {
						setTimeout(() => {
							_sendFun(service, result.jstoken, success, error);
						}, 50);
					}, (data) => {
						if (typeof error === 'function') {
							error.call(this, data);
						}
					});
				}, 50);
			} else if (data.status === 429) {
				if (typeof success === 'function') {
					success.call(this, {
						errcode: 'TOOMANYERROR',
						errmsg: '當前訪問人數過多，請您稍後再試！',
						result: null
					});
				}
			} else {
				if (typeof error === 'function') {
					error.call(this, data);
				}
			}
		});
	} else {
		_getJsToken((result) => {
			setTimeout(() => {
				_sendFun(service, result.jstoken, success, error);
			}, 50);
		}, data => {
			if (typeof error === 'function') {
				error.call(this, data);
			}
		});
	}
}

let _sendFun = (service, jsToken, success, error) => {
	service.params.jstoken = jsToken;
	fly.get(service).then((data) => {
		if (typeof success === 'function') {
			success.call(this, data.data);
		}
	}).catch(errorData => {
		if (typeof error === 'function') {
			error.call(this, errorData);
		}
	});
};

let _getJsToken = (success, error) => {
	fly.get(jsToken()).then((data) => {
		if (typeof success === 'function') {
			if (data.data.jstoken && data.data.jstoken.length > 0) {
				setSession('_tmp_jsToken', data.data.jstoken);
			}
			success.call(this, data.data);
		}
	}).catch(errorData => {
		if (typeof error === 'function') {
			error.call(this, errorData);
		}
	});
}
//原生获取token



Vue.config.productionTip = false;
console.log(routerMode)
//路由配置
const router = new VueRouter({
	routes,
	mode: routerMode,
	base: routerbase,
	fallback: false,
	strict: process.env.NODE_ENV !== 'production',
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			if (from.meta.keepAlive) {
				from.meta.savedPosition = document.body.scrollTop;
			}
			return {
				x: 0,
				y: to.meta.savedPosition || 0
			}
		}
	}
})

//注册路由
Vue.use(VueRouter)
/* eslint-disable no-new */
//挂载模板
new Vue({
	el: '#app',
	router,
	// store,
	components: {
		App
	},
	template: '<App/>'
});

if (!("classList" in document.documentElement)) {
	Object.defineProperty(HTMLElement.prototype, 'classList', {
		get: function () {
			var self = this;

			function update(fn) {
				return function (value) {
					var classes = self.className.split(/\s+/g),
						index = classes.indexOf(value);

					fn(classes, index, value);
					self.className = classes.join(" ");
				}
			}

			return {
				add: update(function (classes, index, value) {
					if (!~index) classes.push(value);
				}),

				remove: update(function (classes, index) {
					if (~index) classes.splice(index, 1);
				}),

				toggle: update(function (classes, index, value) {
					if (~index)
						classes.splice(index, 1);
					else
						classes.push(value);
				}),

				contains: function (value) {
					return !!~self.className.split(/\s+/g).indexOf(value);
				},

				item: function (i) {
					return self.className.split(/\s+/g)[i] || null;
				}
			};
		}
	});
}



// WEBPACK FOOTER //
// ./src/main.js